import React, { useCallback, useRef, useState } from 'react';
import { pagePreviews, proofStrip } from '../data/coachSystem';
import { SectionEyebrow } from './SectionEyebrow';
export function PagePreviewSection() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const handleScroll = useCallback(() => {
    const track = trackRef.current;
    if (!track) return;
    const slide = track.firstElementChild as HTMLElement | null;
    if (!slide) return;
    const step = slide.offsetWidth + 12;
    setActiveIndex(Math.min(pagePreviews.length - 1, Math.max(0, Math.round(track.scrollLeft / step))));
  }, []);
  return <section className="border-y border-char-line bg-char-light py-11 sm:py-14" aria-labelledby="previews-title" data-id="element-94" data-mp="2rewaqlykg0v7">
      <div className="mx-auto w-full max-w-[42rem] px-4 text-center sm:px-6 lg:max-w-6xl" data-id="element-95" data-mp="ulbcjx1wjjne">
        <SectionEyebrow label="Real pages from the system" data-id="element-96" data-mp="pmzyfa4kqmzd" />
        <h2 id="previews-title" className="mt-4 font-display text-[1.8rem] font-semibold uppercase leading-[1.1] tracking-tight text-ivory sm:text-[2.3rem]" data-id="element-97" data-mp="3cf8gar7ty8hi">
          See what you’ll actually coach with
        </h2>
        <p className="mx-auto mt-3.5 max-w-[38rem] text-[0.95rem] leading-relaxed text-ivory-muted sm:text-[1rem]" data-id="element-98" data-mp="32i2plk34ojht">
          Real pages from Basketball Coach System™ — built to help you choose a
          practice, understand the setup and take it straight to the court.
        </p>
      </div>

      <ul ref={trackRef} onScroll={handleScroll} className="no-scrollbar mt-7 flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-smooth px-4 pb-1 sm:px-6 lg:mx-auto lg:grid lg:max-w-6xl lg:grid-cols-3 lg:gap-5 lg:overflow-visible lg:px-6" data-id="element-99" data-mp="3ydp490eacj9">
        {pagePreviews.map((page, index) => <li key={page.id} className="w-[82vw] shrink-0 snap-start lg:w-auto" aria-current={index === activeIndex ? 'true' : undefined} data-id="element-100" data-mp="hxln4yktnelv" data-mpi={index}>
            <figure className="flex h-full flex-col overflow-hidden rounded-xl border border-char-line bg-ink shadow-card" data-id="element-101" data-mp="wkkhb1b2cn4a">
              <img src={page.src} alt={page.alt} loading="lazy" className="w-full object-contain" data-id="element-102" data-mp="rkpnaovzrhf0" />
              <figcaption className="border-t border-char-line px-3.5 py-2.5 text-left" data-id="element-103" data-mp="ilkqpo3zpy5h">
                <span className="block font-display text-[0.58rem] font-semibold uppercase text-orange" style={{
              letterSpacing: '0.22em'
            }} data-id="element-104" data-mp="dnt0cyizuk3e">
                  {page.label}
                </span>
                <span className="mt-1 block text-[0.82rem] font-semibold leading-snug text-ivory" data-id="element-105" data-mp="3v3iyww57lw6j">
                  {page.title}
                </span>
              </figcaption>
            </figure>
          </li>)}
      </ul>

      <ul className="mt-4 flex items-center justify-center gap-1.5 lg:hidden" aria-hidden="true" data-id="element-106" data-mp="3m2ksy8b7nelb">
        {pagePreviews.map((page, index) => <li key={page.id} className={`h-1.5 rounded-full transition-[width,background-color] duration-200 ease-out ${index === activeIndex ? 'w-5 bg-orange' : 'w-1.5 bg-char-line'}`} data-id="element-107" data-mp="26jv8cp0z3uvt" data-mpi={index} />)}
      </ul>

      <div className="mx-auto mt-8 w-full max-w-[42rem] px-4 sm:px-6 lg:max-w-4xl" data-id="element-108" data-mp="2fjs1p3yb5hx7">
        <div className="rounded-xl border border-char-line bg-ink px-4 py-4 text-center shadow-card" data-id="element-109" data-mp="1ivvjjun82ejv">
          <ul className="flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1.5" data-id="element-110" data-mp="1mwfdkpci121s">
            {proofStrip.map((item, index) => <li key={item} className="flex items-center gap-2.5 font-display text-[0.72rem] font-semibold uppercase tracking-[0.14em] text-ivory-soft sm:text-[0.8rem]" data-id="element-111" data-mp="1wlpbilu0xext" data-mpi={index}>
                {item}
                {index < proofStrip.length - 1 ? <span className="text-orange" aria-hidden="true" data-id="element-112" data-mp="36s345rkmxhvz">
                    •
                  </span> : null}
              </li>)}
          </ul>
          <p className="mt-2.5 text-[0.72rem] font-semibold uppercase tracking-[0.22em] text-ivory-dim" data-id="element-113" data-mp="31r5lzezmknuh">
            Open • Choose • Coach
          </p>
        </div>
      </div>
    </section>;
}